import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {FormattedMessage} from 'react-intl';

import FormattedLink from '@stubhub/react-formatted-link-core';

import BRAND_TYPES, {isValidBrand} from './brandTypes';
import LOGO_TYPES, {isValidType} from './logoTypes';

import '../styles/index.scss';

const Logo = ({
  className,
  onItemClick,
  location,
  href = '/',
  type,
  brand = BRAND_TYPES.DEFAULT,
  defaultLocale,
  currentLocale,
  LinkComp,
  matchRoutes,
}) => {
  const useH1tag = location && /^\/((fr|de|es)\/?)?$/i.test(location.pathname);
  const LogoWrapper = useH1tag ? 'h1' : 'h2';
  const logoType = type && isValidType(type) ? `logo--${type}` : null;
  const logoBrand = brand && isValidBrand(brand) && brand !== BRAND_TYPES.DEFAULT ? `${logoType}-${brand}` : null;
  const logoClassName = cx('logo', className, logoBrand, logoType);

  return (
    <FormattedLink
      defaultLocale={defaultLocale}
      currentLocale={currentLocale}
      LinkComp={LinkComp}
      className="logo__link"
      href={href}
      onClick={() => onItemClick && onItemClick('StubHub Logo')}
      matchRoutes={matchRoutes}
    >
      <LogoWrapper className={logoClassName}>
        <FormattedMessage id="Logo.AltText" defaultMessage="StubHub - Where Fans Buy & Sell Tickets" />
      </LogoWrapper>
    </FormattedLink>
  );
};

Logo.propTypes = {
  /**
   * Custom classname.
   * If logo_merch or logo_white are provided, special styles will be applied though it's bette to use type prop
   */
  className: PropTypes.string,

  /** Callback called when the logo is clicked. It will send 'StubHub Logo' as the argument */
  onItemClick: PropTypes.func,

  /** Current location */
  location: PropTypes.object,

  /** The logo href */
  href: PropTypes.string,

  /** Available styles */
  type: PropTypes.oneOf([LOGO_TYPES.MERCH, LOGO_TYPES.WHITE]),

  /** Logo brand */
  brand: PropTypes.oneOf([BRAND_TYPES.DEFAULT, BRAND_TYPES.ALTERNATIVE]),

  /** The default locale for the site */
  defaultLocale: PropTypes.string,

  /** Current user locale */
  currentLocale: PropTypes.string,

  /** Link component to use if it's not an external link */
  LinkComp: PropTypes.elementType.isRequired,

  /** Function to check if the route matches the app. */
  matchRoutes: PropTypes.func,
};

export default Logo;

export {LOGO_TYPES, BRAND_TYPES, isValidBrand, isValidType};
